import axios from "axios";
import { API_BASE_PATH } from "../environment";

const LOGIN_URL = `${API_BASE_PATH}/login`;
const CHECK_TOKEN_URL = `${API_BASE_PATH}/check-token`;
const LOGOUT_URL = `${API_BASE_PATH}/logout`;
// 🔐 Login User
export const loginUser = async (email: string, password: string, rememberMe: boolean) => {
  try {
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);

    const response = await axios.post(`${LOGIN_URL}?remember_me=${rememberMe}`, formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    // ✅ Save token to localStorage
    if (response.data?.access_token) {
      localStorage.setItem("authToken", response.data.access_token);
    }

    return response.data;
  } catch (error) {
    console.error("Login Error:", error);
    throw new Error("Login failed. Please try again.");
  }
};

// ✅ Check Token Validity
export const checkToken = async (): Promise<{
  status: string;
  message: string;
  user_id: string;
  email: string;
  name: string;
  role: string;
}> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("No token found");
    const response = await axios.get(`${CHECK_TOKEN_URL}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Token Check Failed:", error);
    throw new Error("Invalid or expired token.");
  }
};


// 🚪 Logout User
export const logoutUser = async () => {
  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.warn("Logout attempted with no token");
    } else {
      await axios.post(
        LOGOUT_URL,
        {},
        {
          headers: {
            Authorization: token,
            Accept: "application/json",
          },
        }
      );
    }
  } catch (error) {
    console.error("Logout API Error:", error);
    // Continue with local logout anyway
  }

  // 🧹 Remove ALL login-related data
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("role");
  localStorage.removeItem("client_id");
  localStorage.removeItem("user_id");
  localStorage.removeItem("username");
  localStorage.removeItem("email");
  localStorage.removeItem("expires_at");
  localStorage.removeItem("expires_in_minutes");

  return { message: "Logged out successfully" };
};